import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Loading from "../../Shared/Loading";

const CARD_META = [
  { icon: "solar:verified-check-bold-duotone", accent: "#4f46e5", bg: "bg-indigo-50", text: "text-indigo-600" },
  { icon: "solar:heart-pulse-bold-duotone", accent: "#0ea5e9", bg: "bg-sky-50", text: "text-sky-600" },
  { icon: "solar:shield-check-bold-duotone", accent: "#10b981", bg: "bg-emerald-50", text: "text-emerald-600" },
  { icon: "solar:stethoscope-bold-duotone", accent: "#8b5cf6", bg: "bg-violet-50", text: "text-violet-600" },
  { icon: "solar:medical-kit-bold-duotone", accent: "#f43f5e", bg: "bg-rose-50", text: "text-rose-600" },
  { icon: "solar:chart-square-bold-duotone", accent: "#f59e0b", bg: "bg-amber-50", text: "text-amber-600" },
];

const CARD_KEYS = [
  ["firstCardTitle", "firstCardDes"],
  ["secondCardTitle", "secondCardDes"],
  ["thirdCardTitle", "thirdCardDes"],
  ["fourthCardTitle", "fourthCardDes"],
  ["fifthCardTitle", "fifthCardDes"],
  ["sixthCardTitle", "sixthCardDes"],
];

const WhyMedmyne = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://servercareseebd.careseebd.com/api/v1/whyMedmyne/getwhyMedmyne`)
      .then((r) => r.json())
      .then((d) => { if (d?.data?.length) setData(d.data[0]); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <section className="section-py bg-[#fafafa]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-600 border border-indigo-100 rounded-full px-4 py-1 text-xs font-semibold uppercase tracking-widest mb-5">
            <Icon icon="solar:question-circle-bold" className="w-3.5 h-3.5" />
            Why Choose Us
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-extrabold text-gray-900 tracking-tight">
            {data?.sectionName || "Why Medmyne?"}
          </h2>
          <p className="mt-5 text-base text-gray-500 leading-relaxed">
            {data?.sectionDescription}
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARD_KEYS.map(([titleKey, desKey], i) => {
            const meta = CARD_META[i];
            const title = data?.[titleKey];
            const desc = data?.[desKey];
            if (!title) return null;
            return (
              <div
                key={i}
                className="group relative bg-white rounded-2xl border border-gray-100 p-7 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                {/* Accent line top */}
                <div
                  className="absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl"
                  style={{ background: `linear-gradient(90deg, ${meta.accent}, transparent)` }}
                />

                <div className={`inline-flex w-12 h-12 items-center justify-center rounded-xl ${meta.bg} ${meta.text} mb-5`}>
                  <Icon icon={meta.icon} className="w-6 h-6" />
                </div>

                <h3 className="font-heading text-base font-bold text-gray-900 mb-2 tracking-tight">{title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{desc}</p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <Link
            to="/aboutUs"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-2xl shadow-md hover:-translate-y-0.5 transition-all duration-200"
          >
            More About Us
            <Icon icon="solar:arrow-right-bold" className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyMedmyne;
